import gql from 'graphql-tag';

export const articlePostQuery = gql`
  query getPost($slug: ID!) {
    post(id: $slug, idType: SLUG) {
      author {
        node {
          name
          slug
        }
      }
      categories {
        nodes {
          name
          slug
        }
      }
      coAuthors {
        name
        slug
      }
      content
      date
      excerpt
      featuredImage {
        node {
          altText
          caption
          description
          mediaDetails {
            height
            width
          }
          sourceUrl
        }
      }
      featuredImageWidth
      imageSrcset
      slug
      tags {
        nodes {
          name
          slug
        }
      }
      title
    }
  }
`;
